import { render, staticRenderFns } from "./DeleteDataTurnOffAutomaticInvoiceGeneration.vue?vue&type=template&id=3c6e32b6&scoped=true"
import script from "./DeleteDataTurnOffAutomaticInvoiceGeneration.vue?vue&type=script&lang=js"
export * from "./DeleteDataTurnOffAutomaticInvoiceGeneration.vue?vue&type=script&lang=js"
import style0 from "./DeleteDataTurnOffAutomaticInvoiceGeneration.vue?vue&type=style&index=0&id=3c6e32b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e32b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6e32b6')) {
      api.createRecord('3c6e32b6', component.options)
    } else {
      api.reload('3c6e32b6', component.options)
    }
    module.hot.accept("./DeleteDataTurnOffAutomaticInvoiceGeneration.vue?vue&type=template&id=3c6e32b6&scoped=true", function () {
      api.rerender('3c6e32b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/DeleteDataTurnOffAutomaticInvoiceGeneration.vue"
export default component.exports